import { render, staticRenderFns } from "./modal-force-phone.vue?vue&type=template&id=663144b4&"
import script from "./modal-force-phone.vue?vue&type=script&lang=js&"
export * from "./modal-force-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports